/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CoreAttachmentDto } from "@mm-products/java-multima-framework";
import type { TaxDocumentDto } from "./TaxDocumentDto";

export type TaxDocumentAttachmentDto = {
    readonly _permissions?: Array<string>;
    attachment?: CoreAttachmentDto;
    created?: string;
    creator?: string;
    creatorId?: string;
    document?: TaxDocumentDto;
    id?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    order?: number;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    type?: TaxDocumentAttachmentDto.type;
};

export namespace TaxDocumentAttachmentDto {
    export enum type {
        THUMBNAIL = "THUMBNAIL",
        ORIGINAL = "ORIGINAL",
        ORIGINAL_ISDOC = "ORIGINAL_ISDOC",
        INCOMPLETE_PROOF = "INCOMPLETE_PROOF",
        COMPLETE_PROOF = "COMPLETE_PROOF",
        IMAGE_PAGE = "IMAGE_PAGE",
        EMAIL_EML = "EMAIL_EML",
    }
}
